import { render, staticRenderFns } from "./modal_filter_medsos.vue?vue&type=template&id=bd5c4a2c"
import script from "./modal_filter_medsos.vue?vue&type=script&lang=js"
export * from "./modal_filter_medsos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports